/**
 * perkie-pdp-proto-v4.js — STAGING-ONLY PROTOTYPE (2026-10-15, ledger PM-85,
 * Corey: "go"). Never promote without a ruling; debt D-PROTO-V4 names its
 * removal. Dormant unless sessionStorage perkie_proto === "v4", set by
 * visiting any PDP with ?perkie_proto=v4 (cleared with ?perkie_proto=off).
 * Below 750px only — the desktop plate already takes the art (D23).
 *
 * What it prototypes (panel 10-15, "V4"): the art-on-product composite moves
 * from the 3C card into the product gallery's lead slide; "See it on the
 * piece" scrolls the page to the gallery; WHAT PRINTS + Dawn's price +
 * the variant pickers sit directly under the gallery; the existing sticky
 * Add to cart does the rest. It also measures the four inferred risks the
 * dissent named — scroll distance, URL-bar behaviour, Dawn's setActiveMedia
 * moving the slider on a colour change, composite fidelity next to the
 * hero photo — and logs the first three to the console as
 * "[perkie-proto v4] …".
 *
 * Events READ: perkie:style-selected, perkie:see-on-piece (new, emitted by
 * the card's reveal primary), perkie:previewer-reset. Dispatches nothing.
 */
(function () {
  "use strict";
  var KEY = "perkie_proto";
  try {
    var q = new URLSearchParams(window.location.search).get(KEY);
    if (q === "v4") window.sessionStorage.setItem(KEY, "v4");
    else if (q === "off") window.sessionStorage.removeItem(KEY);
  } catch (e) { /* ignore */ }
  var on = false;
  try { on = window.sessionStorage.getItem(KEY) === "v4"; } catch (e) { on = false; }
  if (!on) return;
  if (window.__perkieProtoV4) return;
  window.__perkieProtoV4 = true;
  if (window.matchMedia && window.matchMedia("(min-width: 750px)").matches) {
    console.info("[perkie-proto v4] 750px and up: inactive (the prototype is the phone only)");
    return;
  }
  var root = document.querySelector("product-info");
  if (!root) return;
  var mount = root.querySelector('[data-perkie-previewer="product"]');
  var gallery = root.querySelector("media-gallery");
  if (!mount || !gallery) return;
  var firstItem = gallery.querySelector(".product__media-item");
  var box = firstItem && firstItem.querySelector(".product__media");
  var slider = gallery.querySelector(".slider");
  if (!box) return;
  // MEASURED 2026-10-16 (built-in browser, 390, Graphic Tee): a colour change
  // makes Dawn's product-info REBUILD the gallery's media list (the per-colour
  // media grouping: 5 new items for Black), not merely scroll it — the
  // overlay node is detached with the old list. So every paint re-mounts it
  // into whatever the lead slide is now, and logs when it had to.
  function mountOverlay(why) {
    var g = root.querySelector("media-gallery") || gallery;
    gallery = g;
    slider = g.querySelector(".slider") || slider;
    var fi = g.querySelector(".product__media-item .product__media");
    if (!fi) return false;
    if (ov.parentNode !== fi) {
      if (ov.parentNode) console.info("[perkie-proto v4] Dawn rebuilt the gallery (" + why + ") — composite re-mounted on the new lead slide");
      fi.appendChild(ov);
    }
    if (under && under.parentNode !== g.parentNode) g.insertAdjacentElement("afterend", under);
    return true;
  }

  document.documentElement.classList.add("perkie-proto-v4");
  console.info("[perkie-proto v4] active");

  var mockup = null, colors = null;
  try { mockup = JSON.parse(mount.getAttribute("data-perkie-mockup") || "null"); } catch (e) { mockup = null; }
  try { colors = JSON.parse(mount.getAttribute("data-perkie-mockup-colors") || "null"); } catch (e) { colors = null; }
  var baseBlank = mockup && mockup.blankMockup ? mockup.blankMockup : null;
  var baseSlot = mockup && mockup.slot ? mockup.slot : null;
  var cylinder = !!(baseSlot && baseSlot.curvature === "cylinder");

  /* ── the overlay on the lead slide (same box, nothing moves — D23's rule) ── */
  var ov = document.createElement("div");
  ov.className = "perkie-proto-v4__ov";
  ov.hidden = true;
  ov.innerHTML =
    '<span class="perkie-proto-v4__stage' + (cylinder ? " is-cylinder" : "") + '">' +
      (baseBlank ? '<img class="perkie-proto-v4__blank" alt="">' : "") +
      '<img class="perkie-proto-v4__art" alt="">' +
    "</span>" +
    '<span class="perkie-proto-v4__cap"></span>';
  box.appendChild(ov);
  var under = null;
  var blankEl = ov.querySelector(".perkie-proto-v4__blank");
  var artEl = ov.querySelector(".perkie-proto-v4__art");
  var capEl = ov.querySelector(".perkie-proto-v4__cap");

  /* ── the block under the gallery: WHAT PRINTS · price · pickers · the line ── */
  under = document.createElement("div");
  under.className = "perkie-proto-v4__under";
  under.hidden = true;
  under.innerHTML =
    '<p class="perkie-proto-v4__line"><span class="perkie-proto-v4__prints"></span><span class="perkie-proto-v4__price"></span></p>' +
    '<div class="perkie-proto-v4__pickers"></div>' +
    '<p class="perkie-proto-v4__trust">Preview on product. A real artist reviews your order before it prints, and you approve a proof before it ships.</p>';
  gallery.insertAdjacentElement("afterend", under);
  var printsEl = under.querySelector(".perkie-proto-v4__prints");
  var priceEl = under.querySelector(".perkie-proto-v4__price");
  var pickersHome = under.querySelector(".perkie-proto-v4__pickers");

  var vs = root.querySelector("variant-selects");
  var vsAnchor = null;
  function movePickersUnder() {
    if (!vs || vs.parentNode === pickersHome) return;
    vsAnchor = document.createComment("perkie-proto-v4 pickers moved");
    vs.parentNode.insertBefore(vsAnchor, vs);
    pickersHome.appendChild(vs);
  }
  function restorePickers() {
    if (!vs || !vsAnchor || !vsAnchor.parentNode) return;
    vsAnchor.parentNode.insertBefore(vs, vsAnchor);
    vsAnchor.parentNode.removeChild(vsAnchor);
    vsAnchor = null;
  }

  function readPrice() {
    var el = root.querySelector(".product__info-container .price .price-item--sale") ||
             root.querySelector(".product__info-container .price .price-item--regular") ||
             root.querySelector(".product__info-container .price .price-item");
    return el ? el.textContent.replace(/\s+/g, " ").trim() : "";
  }

  /* ── colour: which blank, and the honest line when none matches ── */
  function selectedColorSlug() {
    if (!colors || !vs || colors.colorIndex == null || colors.colorIndex < 0) return null;
    try {
      var s = vs.querySelector("script[data-selected-variant]");
      var v = s ? JSON.parse(s.textContent) : null;
      var val = v && v.options ? v.options[colors.colorIndex] : null;
      return val ? String(val).trim().toLowerCase().replace(/\s+/g, "-") : null;
    } catch (e) { return null; }
  }
  function applyColor() {
    var slot = baseSlot, blank = baseBlank, note = "";
    var slug = selectedColorSlug();
    if (slug && colors) {
      if (slug === colors.color) { /* the main blank shows this colour */ }
      else {
        var hit = null;
        (colors.more || []).forEach(function (m) { if (!hit && m && m[0] === slug && m[1]) hit = m; });
        if (hit) {
          blank = hit[1];
          if (hit[2]) { var p = String(hit[2]).split(","); if (p.length === 4) slot = { left: +p[0], top: +p[1], width: +p[2], height: +p[3], curvature: baseSlot ? baseSlot.curvature : "flat" }; }
        } else if (colors.color) {
          note = " · SHOWN IN " + String(colors.color).replace(/-/g, " ").toUpperCase();
        }
      }
    }
    if (blankEl && blank) blankEl.src = blank;
    if (artEl && slot) { artEl.style.left = slot.left + "%"; artEl.style.top = slot.top + "%"; artEl.style.width = slot.width + "%"; artEl.style.height = slot.height + "%"; }
    return note;
  }

  var state = { art: null, label: "", names: "" };
  function paint() {
    if (!state.art) return;
    if (!mountOverlay("paint")) return;
    var note = applyColor();
    artEl.src = state.art;
    capEl.textContent = (state.names ? state.names + " · " : "") + state.label + " · PREVIEW" + note;
    printsEl.textContent = (state.names ? state.names + " · " : "") + state.label + " · one piece";
    priceEl.textContent = readPrice();
    ov.hidden = false;
    under.hidden = false;
    movePickersUnder();
    pinLeadSlide("paint");
  }
  function pinLeadSlide(why) {
    if (!slider) return;
    var moved = Math.round(slider.scrollLeft);
    if (moved > 2) console.info("[perkie-proto v4] slider was at " + moved + "px (" + why + ") — re-pinning the composite slide");
    try { slider.scrollTo({ left: 0, behavior: "auto" }); } catch (e) { slider.scrollLeft = 0; }
  }

  window.addEventListener("perkie:style-selected", function (e) {
    var d = e && e.detail ? e.detail : {};
    var pets = Array.isArray(d.pets) ? d.pets : [];
    var art = d.combinedPreviewUrl || (pets[0] && pets[0].previewUrl) || null;
    if (!art) return;
    state.art = art;
    state.label = String(d.styleLabel || d.style || "").toUpperCase();
    state.names = pets.map(function (p) { return (p && p.name ? String(p.name).trim() : ""); }).filter(Boolean).join(" + ").toUpperCase();
    paint();
  });

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.addEventListener("perkie:see-on-piece", function () {
    if (!state.art) return;
    var top = gallery.getBoundingClientRect().top;
    console.info("[perkie-proto v4] See it on the piece: gallery is " + Math.round(top) + "px from the viewport top; innerHeight " + window.innerHeight);
    try { gallery.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" }); } catch (e) { gallery.scrollIntoView(); }
    var h0 = window.innerHeight;
    setTimeout(function () {
      console.info("[perkie-proto v4] after scroll: gallery top " + Math.round(gallery.getBoundingClientRect().top) + "px; innerHeight " + window.innerHeight + (window.innerHeight !== h0 ? " (URL bar changed the viewport by " + (window.innerHeight - h0) + "px)" : ""));
      var cap = under.querySelector(".perkie-proto-v4__line"); if (cap) { cap.setAttribute("tabindex", "-1"); try { cap.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }, reduce ? 50 : 700);
  });

  window.addEventListener("perkie:previewer-reset", function () {
    state.art = null; ov.hidden = true; under.hidden = true; restorePickers();
  });

  /* ── Dawn's variant change: measure setActiveMedia, then re-pin and recolour ── */
  function afterVariant(src) {
    if (!state.art) return;
    setTimeout(function () {
      var s = (root.querySelector("media-gallery") || gallery).querySelector(".slider");
      if (s && Math.round(s.scrollLeft) > 2) console.info("[perkie-proto v4] Dawn setActiveMedia moved the slider to " + Math.round(s.scrollLeft) + "px after a variant change (" + src + ")");
      if (!ov.isConnected) console.info("[perkie-proto v4] the composite slide was DESTROYED by the variant change (" + src + ")");
      paint();
    }, 350);
  }
  document.addEventListener("change", function (e) { if (vs && vs.contains(e.target)) afterVariant("change"); });
  if (typeof window.subscribe === "function" && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
    try { window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { afterVariant("variantChange"); }); } catch (e) { /* ignore */ }
  }
})();
